// extracted by mini-css-extract-plugin
module.exports = {"sidebarChat":"SidebarChat_sidebarChat__xrmik","sidebarChat__info":"SidebarChat_sidebarChat__info__23AmZ"};